import React, { Component } from 'react';
import './index.css';

import Chartable from '../Chartable'

class ChartWrapper extends Component {
  render() {
    return (
      <div className="chart-wrapper">
        <Chartable data={this.props.data} />
      </div>
    )
  }
}

export default ChartWrapper



// WEBPACK FOOTER //
// ./src/ChartWrapper/index.js